<template>
  <DropdownMenu :auto-close="false" class="focus:z-10 hover:text-white px-4 focus:border-white rounded-l focus:ring md:px-0" placement="right-start">
    <template #default>
      <div class="flex">
        <icon :name="name_icon" class="mr-2 w-4 h-4" :class="isUrl(route) ? 'fill-white' : 'fill-sky-400 group-hover:fill-white'" />
        <span class="pt-1 hidden hover:text-white md:inline" :class="isUrl(route) ? 'text-white' : 'text-sky-300'">{{ name }}</span>
      </div> 
    </template>
    <template #dropdown>
      <div class="pl-2 bg-sky-500 rounded">
        <slot />
      </div>
    </template>
  </DropdownMenu>
</template>
<script>
import DropdownMenu from '@/Shared/DropdownMenu'
import Icon from '@/Shared/Icon'

export default {
  components: {
    DropdownMenu,
    Icon,
  },
  props: {
    name: String,
    route: String,
    name_icon:String
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if(urls[0] === '')
        return currentUrl === ''

      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}
</script>